const formatFleetType = (fleetType) => {
  switch (fleetType) {
    case 'MIXED':
      return 'Mista'
    case 'SELF':
      return 'Pŕopria'
    default:
      return 'Terceira'
  }
}

export const VEHICLE_TYPE_SELECT = {
  TRUCK: 'Truck',
  BITRUCK: 'Bitruck',
  TOCO: 'Toco',
  TRES_QUARTO: '3/4',
  VLC: 'VLC',
  CARRETA: 'Carreta',
  CARRETA_LS: 'Carreta LS',
  CARRETA_VANDERLEIA: 'Carreta Vanderleia',
  BITREM: 'Bitrem',
  RODOTREM: 'Rodotrem',
  TRITEREM: 'Treminhão',
}

export const VEHICLE_TYPE = {
  TRUCK: 'Truck',
  BITRUCK: 'Bitruck',
  TOCO: 'Toco',
  TRES_QUARTO: '3/4',
  VLC: 'VLC',
  CARRETA: 'Carreta',
  CARRETA_LS: 'Carreta LS',
  CARRETA_VANDERLEIA: 'Carreta Vanderleia',
  BITREM: 'Bitrem',
  RODOTREM: 'Rodotrem',
  TRITEREM: 'Treminhão',
  TRUCK_TRACTOR: 'Cavalo Trucado',
  SIMPLE_TRACTOR: 'Cavalo Simples',
  TRAILER: 'Carroceria',
}

export const VEHICLE_TYPE_PICKER = [
  {
    description: 'Truck',
    label: 'Truck',
    key: 'TRUCK',
    numbers: 1,
    category: 'MEDIO',
    subType: 'TRUCK',
  },
  {
    description: 'Bitruck',
    label: 'Bitruck',
    key: 'BITRUCK',
    numbers: 1,
    category: 'MEDIO',
    subType: 'BITRUCK',
  },
  {
    description: 'Toco',
    label: 'Toco',
    key: 'TOCO',
    numbers: 1,
    category: 'LEVE',
    subType: 'TOCO',
  },
  {
    description: '3/4',
    label: '3/4',
    key: 'TRES_QUARTO',
    numbers: 1,
    category: 'LEVE',
    subType: 'TRES_QUARTO',
  },
  { description: 'VLC', label: 'VLC', key: 'VLC', numbers: 1, category: 'LEVE', subType: 'VLC' },
  {
    description: 'Carreta',
    label: 'Carreta',
    key: 'CARRETA',
    numbers: 2,
    category: 'PESADO',
    subType: 'SIMPLE_TRACTOR',
  },
  {
    description: 'Carreta LS',
    label: 'Carreta LS',
    key: 'CARRETA_LS',
    numbers: 2,
    category: 'PESADO',
    subType: 'TRUCK_TRACTOR',
  },
  {
    description: 'Vanderleia',
    label: 'Vanderleia',
    key: 'CARRETA_VANDERLEIA',
    numbers: 2,
    category: 'PESADO',
    subType: 'TRUCK_TRACTOR',
  },
  {
    description: 'Bitrem',
    label: 'Bitrem',
    key: 'BITREM',
    numbers: 3,
    category: 'PESADO',
    subType: 'TRUCK_TRACTOR',
  },
  {
    description: 'Rodotrem',
    label: 'Rodotrem',
    key: 'RODOTREM',
    numbers: 3,
    category: 'PESADO',
    subType: 'TRUCK_TRACTOR',
  },
  {
    description: 'Triterem',
    label: 'Treminhão',
    key: 'TRITEREM',
    numbers: 4,
    category: 'PESADO',
    subType: 'TRUCK_TRACTOR',
  },
  {
    description: 'Tetraminhão',
    label: 'Tetraminhão',
    key: 'TETRAMINHAO',
    numbers: 5,
    category: 'PESADO',
    subType: 'TRUCK_TRACTOR',
  },
  {
    description: 'Pentaminhão',
    label: 'Pentaminhão',
    key: 'PENTAMINHAO',
    numbers: 6,
    category: 'PESADO',
    subType: 'TRUCK_TRACTOR',
  },
]

export const VEHICLE_TYPE_INDEX = {
  TRUCK: 0,
  BITRUCK: 1,
  TOCO: 2,
  TRES_QUARTO: 3,
  VLC: 5,
  CARRETA: 4,
  CARRETA_LS: 6,
  CARRETA_VANDERLEIA: 9,
  BITREM: 7,
  RODOTREM: 8,
  TETRAMINHAO: 10,
  PENTAMINHAO: 11,
  TRUCK_TRACTOR: 12,
  SIMPLE_TRACTOR: 13,
}

export const TRAILER_TYPE = {
  BAU: 'Baú',
  BAU_FRIGORIFICO: 'Baú Frigorífico',
  BUG_PORTA_CONTAINER: 'Baú Porta Container',
  CACAMBA: 'Caçamba',
  CEGONHEIRO: 'Cegonheiro',
  GAIOLA: 'Gaiola',
  GRADE_BAIXA: 'Grade Baixa',
  GRANELEIRO: 'Graneleiro',
  MUNCK: 'Munck',
  PRANCHA: 'Prancha',
  SIDER: 'Sider',
  SILO: 'Silo',
  TANQUE: 'Tanque',
}

export const TRAILER_TYPE_PICKER = [
  { description: 'Baú', label: 'Baú', key: 'BAU', category: 'FECHADA' },
  {
    description: 'Baú Frigorífico',
    label: 'Baú Frigorífico',
    key: 'BAU_FRIGORIFICO',
    category: 'FECHADA',
  },
  {
    description: 'Baú Porta Container',
    label: 'Baú Porta Container',
    key: 'BUG_PORTA_CONTAINER',
    category: 'FECHADA',
  },
  { description: 'Caçamba', label: 'Caçamba', key: 'CACAMBA', category: 'FECHADA' },
  { description: 'Cegonheiro', label: 'Cegonheiro', key: 'CEGONHEIRO', category: 'FECHADA' },
  { description: 'Gaiola', label: 'Gaiola', key: 'GAIOLA', category: 'FECHADA' },
  { description: 'Grade Baixa', label: 'Grade Baixa', key: 'GRADE_BAIXA', category: 'FECHADA' },
  { description: 'Graneleiro', label: 'Graneleiro', key: 'GRANELEIRO', category: 'FECHADA' },
  { description: 'Munck', label: 'Munck', key: 'MUNCK', category: 'FECHADA' },
  { description: 'Prancha', label: 'Prancha', key: 'PRANCHA', category: 'FECHADA' },
  { description: 'Sider', label: 'Sider', key: 'SIDER', category: 'FECHADA' },
  { description: 'Silo', label: 'Silo', key: 'SILO', category: 'FECHADA' },
  { description: 'Tanque', label: 'Tanque', key: 'TANQUE', category: 'FECHADA' },
]
export const TRAILER_TYPE_INDEX = {
  BAU: 0,
  BAU_FRIGORIFICO: 1,
  BUG_PORTA_CONTAINER: 2,
  CACAMBA: 3,
  CEGONHEIRO: 4,
  GAIOLA: 5,
  GRADE_BAIXA: 6,
  GRANELEIRO: 7,
  MUNCK: 8,
  PRANCHA: 9,
  SIDER: 10,
  SILO: 11,
  TANQUE: 12,
}

export const CATEGORY_MAP = {
  PESADO: 'Pesado',
  LEVE: 'Leve',
  MEDIO: 'Médio',
}

export { formatFleetType }

export const AXIS_OPTIONS = [
  { value: 2, label: '2 eixos' },
  { value: 3, label: '3 eixos' },
  { value: 4, label: '4 eixos' },
  { value: 6, label: '6 eixos' },
  { value: 9, label: '9 eixos' },
]
